var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',{staticStyle:{"text-align":"right","font-size":"12px"}},[_c('el-menu',{attrs:{"mode":"horizontal","background-color":"#fff","text-color":"#303133","active-text-color":"#303133"}},[_c('el-menu-item',{attrs:{"index":"0"},on:{"click":function($event){return _vm.toggle()}}},[_c('i',{staticClass:"fa fa-bars fa-2x"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4afb7322","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/TopNavbar.vue
// module id = UDh6
// module chunks = 1